import React from "react";
import "../assets/Home.css";

import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";

const Home = () => {
  return (
    <div className="scroll-container">
      <Section1 className="section" />
      <Section2 className="section" />
      <Section3 className="section" />
    </div>
  );
};

export default Home;
